<template>
  <v-card class="mb-4 student-class-tile pb-0">
    <v-card-text class="pb-0">
      <v-row row justify-space-between wrap>
        <v-col cols="12" sm="5" md="5">
          <h3>
            {{
              customClass.year_levels[0] && customClass.year_levels[0].value
                ? customClass.year_levels[0].value + ' | '
                : ''
            }}
            {{ customClass.name }}
          </h3>
        </v-col>
        <v-col cols="12" sm="7" md="7">
          <div
            v-if="!customClass.class_invitation_deleted"
            class="text-left text-sm-right sm:mt-2"
          >
            <v-chip
              class="mr-2 mb-2"
              v-for="(item, index) in customClass.lessons"
              :key="index"
              label
              disabled
              outlined
              text-color="black"
              color="grey lighten-2"
            >
              {{ item.name }}
            </v-chip>
          </div>
        </v-col>
        <v-col cols="12" md="3">
          <v-card v-if="customClass.class_invitation_deleted" flat>
            <v-card-title color="error" class="pl-0">
              <v-icon color="error" class="pr-1">info</v-icon>
              You have been un-enrolled from this class
            </v-card-title>
          </v-card>
        </v-col>
        <v-col cols="12" md="9">
          <v-card-actions class="class-item-action">
            <v-spacer />
            <v-btn
              :disabled="customClass.class_invitation_deleted ? true : false"
              @click="classTileClick('messages')"
              :class="[
                'class-item-button',
                {
                  activeButton:
                    currentParentTab == 'messages' &&
                    currentClassId === customClass.id
                }
              ]"
              :dark="
                currentParentTab == 'messages' &&
                currentClassId === customClass.id
                  ? true
                  : false
              "
            >
              <v-icon left>announcement</v-icon> Announcements
            </v-btn>
            <v-btn
              :disabled="customClass.class_invitation_deleted ? true : false"
              @click="classTileClick('lessons')"
              :class="[
                'class-item-button',
                {
                  activeButton:
                    currentParentTab == 'lessons' &&
                    currentClassId === customClass.id
                }
              ]"
              :dark="
                currentParentTab == 'lessons' &&
                currentClassId === customClass.id
                  ? true
                  : false
              "
            >
              <v-icon left>class</v-icon> my {{ lessonTerm }}s
            </v-btn>
            <v-btn
              @click="classTileClick('results')"
              :class="[
                'class-item-button',
                {
                  activeButton:
                    currentParentTab == 'results' &&
                    currentClassId === customClass.id
                }
              ]"
              :dark="
                currentParentTab == 'results' &&
                currentClassId === customClass.id
                  ? true
                  : false
              "
            >
              <v-icon left>pie_chart</v-icon> my results
            </v-btn>
          </v-card-actions>
        </v-col>
      </v-row>
    </v-card-text>

    <div
      :style="{
        position: 'relative',
        backgroundColor: 'var(--v-primary-base)',
        height: '25px'
      }"
    ></div>

    <v-slide-y-transition>
      <div
        class="tab-wrap"
        v-if="
          currentParentTab == 'messages' && currentClassId === customClass.id
        "
      >
        <class-messages
          @close-tab="currentParentTab = null"
          :customClass="customClass"
          @goToLessons="classTileClick('lessons')"
          @edited="classTileClick('messages')"
        />
      </div>
      <div
        class="tab-wrap"
        v-else-if="
          currentParentTab == 'lessons' && currentClassId === customClass.id
        "
      >
        <lessons
          :customClass="customClass"
          @close-tab="currentParentTab = null"
        />
      </div>
      <div
        class="tab-wrap"
        v-else-if="
          currentParentTab == 'results' && currentClassId === customClass.id
        "
      >
        <results @close-tab="currentParentTab = null" />
      </div>
    </v-slide-y-transition>
  </v-card>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import ClassMessages from './messages/ClassMessages'
import Lessons from './lessons/Lessons'
import Results from './results/Results'
import Class from '@/modules/class/models/Class'

export default {
  name: 'ClassItemStudent',
  components: {
    ClassMessages,
    Lessons,
    Results
  },
  props: {
    customClass: {
      type: Object,
      require: true
    },
    isExpandable: {
      type: Boolean,
      default: true,
      require: false
    }
  },
  data() {
    return {
      disableExpand: true,
      newClass: false,
      currentParentTab: null
    }
  },
  watch: {
    isExpandable(val) {
      if (!val) {
        this.currentParentTab = null
      }
    }
  },
  computed: {
    ...mapState(['lessonTerm']),
    ...mapGetters('entities/classes', ['currentClassId']),
    schoolName() {
      // const authTeacher = this.$store.getters['entities/auths/query']().first()

      // if (!authTeacher) return ''

      // return `${authTeacher.school_name}`
      return 'School Name'
    }
  },
  mounted() {
    this.currentParentTab = this.$route.query.currentParentTab
  },
  methods: {
    async setCurrentClassId() {
      await Class.dispatch('setCurrent', this.customClass.id)
    },
    classTileClick(type) {
      if (this.currentClassId === this.customClass.id) {
        if (this.currentParentTab == type) {
          this.currentParentTab = null
        } else {
          this.currentParentTab = type
        }
      } else {
        this.currentParentTab = type
        this.setCurrentClassId()
      }
      this.$emit('expand')
      this.setQuery()
    },
    setQuery() {
      let query = Object.assign({}, this.$route.query)

      if (this.currentParentTab != null) {
        query.currentClassId = this.currentClassId
        query.currentParentTab = this.currentParentTab
        delete query.create
      } else {
        delete query.currentClassId
        delete query.currentParentTab
      }
      this.$router.push({ query: query })
    }
  }
}
</script>

<style lang="scss" scoped>
.student-class-tile {
  .class-tile-text {
    line-height: 52px;
    margin: 0;
  }

  .class-item-action {
    @include breakpoint($sm) {
      display: block;
    }
  }
  .class-item-button {
    margin-left: 15px;

    @include breakpoint($sm) {
      display: block;
      width: 100%;
      margin-left: 0 !important;
      margin-top: 15px;
    }
    &.activeButton {
      background: var(--v-primary-base) !important;
      box-shadow: none !important;
      height: 65px;
      margin-bottom: -26px;

      @include breakpoint($sm) {
        margin: 0;
        margin-top: 15px;
        height: 36px;
        box-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0.2),
          0px 2px 2px 0px rgba(0, 0, 0, 0.14),
          0px 1px 5px 0px rgba(0, 0, 0, 0.12) !important;
      }
    }
  }
}
</style>
